<template>
  <!-- All Invoice -->
  <div class="card invoices-tabs-card">
    <div class="invoices-main-tabs">
      <div class="row align-items-center">
        <div class="col-lg-12">
          <div class="invoices-tabs">
                 <div class="col-md-3 mb-3">
                
          <div class="form-custom">
            <input
              type="text"
              class="form-control form-control-sm"
              placeholder="Search anything..."
              :value="modelValue"
              @input="$emit('update:modelValue', $event.target.value)"
            />
        
          </div>
        </div>
            <ul class="pb-4 pb-lg-0">
              <li>
                <router-link
                  :class="currentPath == 'invoices' ? 'active' : 'notactive'"
                  to="/invoices"
                  >All invoice</router-link
                >
              </li>
              <li>
                <router-link
                  :class="
                    currentPath == 'invoices-pending' ? 'active' : 'notactive'
                  "
                  to="/invoices-pending"
                  >Pending</router-link
                >
              </li>
              <li>
                <router-link
                  :class="
                    currentPath == 'invoices-paid' ? 'active' : 'notactive'
                  "
                  to="/invoices-paid"
                  >Paid</router-link
                >
              </li>
              <li>
                <router-link
                  :class="
                    currentPath == 'invoices-partially-paid'
                      ? 'active'
                      : 'notactive'
                  "
                  to="/invoices-partially-paid"
                  >Partially paid</router-link
                >
              </li>
              <li>
                <router-link
                  :class="
                    currentPath == 'invoices-overdue' ? 'active' : 'notactive'
                  "
                  to="/invoices-overdue"
                  >Overdue</router-link
                >
              </li>
              <li>
                <router-link
                  :class="
                    currentPath == 'invoices-recurring' ? 'active' : 'notactive'
                  "
                  to="/invoices-recurring"
                  >Reoccurring</router-link
                >
              </li>
              <li>
                <router-link
                  :class="
                    currentPath == 'invoices-refunded' ? 'active' : 'notactive'
                  "
                  to="invoices-refunded"
                  >Refunded</router-link
                >
              </li>
              <li>
                <router-link
                  :class="
                    currentPath == 'invoices-draft' ? 'active' : 'notactive'
                  "
                  to="/invoices-draft"
                  >Draft</router-link
                >
              </li>
          
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /All Invoice -->
</template>
<script>
export default {
  props: {
    modelValue: String,
  },
  computed: {
    currentPath() {
      return this.$route.name;
    },
  },
};
</script>
<style lang="css" scoped>

.search-width {
  width: 400px;
}
</style>
